






































import { Component } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';

@Component({ name: 'DeleteIntegration' })
export default class extends SaascadaVueDialog {

    dialog = false;

    async cancel() {
        this.dialog = false;
    }

    async save() {
        this.dialog = false;
    }

}
